import { createSelector } from "reselect";

const getStateAuthSelector = (state) => state.auth;

export const getAuthUserSelector = createSelector(
  getStateAuthSelector,
  (auth) => {
    if (auth?.user) {
      return auth.user;
    }

    return undefined;
  }
);

export const getDataTokenSelector = createSelector(
  getStateAuthSelector,
  (auth) => {
    if (auth?.dataToken) {
      return auth.dataToken;
    }

    return undefined;
  }
);

export const getIsMangerSelector = createSelector(
  getAuthUserSelector,
  (auth) => {
    if (auth?.roles && auth.roles.includes("manager")) {
      return true;
    }

    return false;
  }
);
